var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 " + _vm.size + " " + _vm.size,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M3.25 16.25H6.5V12.375C6.5 11.8227 6.94772 11.375 7.5 11.375H22.75V3.25C22.75 2.35254 22.0225 1.625 21.125 1.625H3.25C2.35254 1.625 1.625 2.35254 1.625 3.25V14.625C1.625 15.5225 2.35254 16.25 3.25 16.25ZM10.7004 10.465L14.3556 8.19067C14.4385 8.13866 14.5065 8.06841 14.5534 7.98611C14.6004 7.90382 14.625 7.812 14.625 7.71875C14.625 7.6255 14.6004 7.53368 14.5534 7.45139C14.5065 7.36909 14.4385 7.29884 14.3556 7.24683L10.7004 4.97252C10.6087 4.91467 10.5018 4.88123 10.3913 4.87579C10.2808 4.87035 10.1708 4.89311 10.0731 4.94162C9.97535 4.99014 9.89365 5.06258 9.83674 5.15117C9.77982 5.23976 9.74983 5.34114 9.75 5.44444V9.99306C9.74983 10.0964 9.77982 10.1977 9.83674 10.2863C9.89365 10.3749 9.97535 10.4474 10.0731 10.4959C10.1708 10.5444 10.2808 10.5672 10.3913 10.5617C10.5018 10.5563 10.6087 10.5228 10.7004 10.465Z",
          fill: _vm.color
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M24.3741 23.4187C24.3747 23.4042 24.375 23.3897 24.375 23.375V14C24.375 13.4477 23.9273 13 23.375 13H9.125C8.98922 13 8.85976 13.0271 8.74172 13.0761L14.7294 17.0376L15.2941 15.4375H17.1412L18.6674 19.6431L24.3741 23.4187Z",
          fill: _vm.color
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M17.5255 20.8361L17.9059 21.9375H19.1902L22.8744 24.375H9.125C8.57272 24.375 8.125 23.9273 8.125 23.375V14.6165L14.1719 18.6172L13 21.9375H14.5588L15.0412 20.4555H16.9503L17.5255 20.8361Z",
          fill: _vm.color
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M16.662 18.3163L16.2 16.9455L15.9191 17.8248L16.662 18.3163Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-028a24be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-028a24be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/play_control/caption_off.vue
// module id = null
// module chunks = 